// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/';

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';

import layer from 'vue-layer';
import 'vue-layer/lib/vue-layer.css';

import echarts from 'echarts';
Vue.prototype.$echarts = echarts

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

import {get, post, deleteRequest, postRequest, putRequest,downloadFileRequest } from './api/http';
Vue.prototype.$post = post;
Vue.prototype.$get = get;
//Vue.prototype.$getRequest=getRequest;
Vue.prototype.$postRequest = postRequest;
Vue.prototype.$putRequest = putRequest;
Vue.prototype.$deleteRequest = deleteRequest;
Vue.prototype.$downloadFileRequest= downloadFileRequest;
// Vue.prototype.$downloadFile=downloadFile;

//富文本编辑，暂未使用
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor);
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

//通用css样式
import './assets/lib/bootstrap.css';
import './assets/css/reset.css';
import './assets/css/baselist.css';
import './assets/css/ele-reset.css';
//import './assets/css/element-variables.scss';

import './assets/fonts/iconfont.css';


// import 'animate.css';

import JSONExcel from 'vue-json-excel';
//下载excel表
Vue.component("downloadExcel", JSONExcel);

//获取域名及协议
import {codeUrl} from './utils/globalVal';
Vue.prototype.$codeUrl=codeUrl;



//弹出层
Vue.prototype.$layer = layer(Vue, {
    msgtime: 3
});

//自定义指令
import Directive from './utils/directive'
Vue.use(Directive);

import BoskShortcutDatetime from "./page/commons/BoskShortcutDatetime/BoskShortcutDatetime.vue"
Vue.component('bosk-shortcut-datetime',BoskShortcutDatetime)
import BoskShortcutDate from "./page/commons/BoskShortcutDate/BoskShortcutDate.vue"
Vue.component('bosk-shortcut-date',BoskShortcutDate)
import BoskDatePicker from "./page/commons/BoskDatePicker"
Vue.component('bosk-date-picker',BoskDatePicker)
Vue.config.productionTip = false;

let Base64 = require('js-base64').Base64;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})